(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchItem', PatchItem);

    PatchItem.$inject = ['$resource'];

    function PatchItem ($resource) {
        var resourceUrl =  'api/patch-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
